"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPLETE_APPOINTMENT_RESPONSE_EXAMPLE = exports.NO_SHOW_RESPONSE_EXAMPLE = exports.LATE_ARRIVAL_RESPONSE_EXAMPLE = exports.PATIENT_CHECK_IN_RESPONSE_EXAMPLE = exports.PATIENT_ARRIVAL_RESPONSE_EXAMPLE = void 0;
/**
 * Response DTOs for the 5 Check-In endpoints — reuses `AppointmentDto`/
 * `VisitDto`/`AppointmentQueueDto`/`ImmediateQueueEntryResponseDto`
 * (`appointment-common.response.ts`) throughout, and reuses Patient
 * Identity's own `TimelineEntryDto` (`search.response.ts`, frozen,
 * Stage 4C.4) for the timeline enrichment
 * `CheckInApplicationService` adds — never a second declaration of
 * either.
 */
const appointment_common_response_1 = require("./appointment-common.response");
exports.PATIENT_ARRIVAL_RESPONSE_EXAMPLE = appointment_common_response_1.IMMEDIATE_QUEUE_ENTRY_RESPONSE_EXAMPLE;
exports.PATIENT_CHECK_IN_RESPONSE_EXAMPLE = {
    appointment: { ...appointment_common_response_1.APPOINTMENT_RESPONSE_EXAMPLE, status: 'CHECKED_IN', visitId: appointment_common_response_1.VISIT_RESPONSE_EXAMPLE.id },
    visit: appointment_common_response_1.VISIT_RESPONSE_EXAMPLE,
    timeline: [{ type: 'VISIT', id: appointment_common_response_1.VISIT_RESPONSE_EXAMPLE.id, occurredAt: appointment_common_response_1.VISIT_RESPONSE_EXAMPLE.checkInAt }],
};
exports.LATE_ARRIVAL_RESPONSE_EXAMPLE = {
    ...exports.PATIENT_CHECK_IN_RESPONSE_EXAMPLE,
    isLate: true,
};
exports.NO_SHOW_RESPONSE_EXAMPLE = { ...appointment_common_response_1.APPOINTMENT_RESPONSE_EXAMPLE, status: 'NO_SHOW' };
exports.COMPLETE_APPOINTMENT_RESPONSE_EXAMPLE = {
    ...appointment_common_response_1.APPOINTMENT_RESPONSE_EXAMPLE,
    status: 'COMPLETED',
    visitId: appointment_common_response_1.VISIT_RESPONSE_EXAMPLE.id,
};
//# sourceMappingURL=check-in.response.js.map